/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ReorderItemsRequest
 */
export interface ReorderItemsRequest {
  /**
   *
   * @type {string}
   * @memberof ReorderItemsRequest
   */
  companyListId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof ReorderItemsRequest
   */
  orderedItemIds: Array<string>;
}

/**
 * Check if a given object implements the ReorderItemsRequest interface.
 */
export function instanceOfReorderItemsRequest(
  value: object,
): value is ReorderItemsRequest {
  if (!("companyListId" in value) || value["companyListId"] === undefined)
    return false;
  if (!("orderedItemIds" in value) || value["orderedItemIds"] === undefined)
    return false;
  return true;
}

export function ReorderItemsRequestFromJSON(json: any): ReorderItemsRequest {
  return ReorderItemsRequestFromJSONTyped(json, false);
}

export function ReorderItemsRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ReorderItemsRequest {
  if (json == null) {
    return json;
  }
  return {
    companyListId: json["companyListId"],
    orderedItemIds: json["orderedItemIds"],
  };
}

export function ReorderItemsRequestToJSON(json: any): ReorderItemsRequest {
  return ReorderItemsRequestToJSONTyped(json, false);
}

export function ReorderItemsRequestToJSONTyped(
  value?: ReorderItemsRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyListId: value["companyListId"],
    orderedItemIds: value["orderedItemIds"],
  };
}
